import { render, staticRenderFns } from "./summaryStepProperties.vue?vue&type=template&id=3181f6fa&"
import script from "./summaryStepProperties.vue?vue&type=script&lang=js&"
export * from "./summaryStepProperties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports